import React from "react";
import {
    Button,
    Dialog,
    DialogHeader,
    DialogBody,
    DialogFooter,
    Typography,
} from "@material-tailwind/react";
import { GobbyTable, GobbyTableHead, GobbyTableBody, GobbyTableRow, GobbyTableHeader, GobbyTableCell } from "components/ui/gobby-table";

export default function ResponsesSentimentListDialog({
    showResponsesSentimentListDialog,
    setShowResponsesSentimentListDialog,
    responsesSentimentData,
    responseSentimentIdList,
}) {
    const handleClose = () => {
        setShowResponsesSentimentListDialog((showResponsesSentimentListDialog) => !showResponsesSentimentListDialog);
    };
    const percentFormat = (decimal) => {
        let formattedPercent;
        if (Number.isFinite(decimal)) {
            formattedPercent = Intl.NumberFormat("default", {
                style: "percent",
                minimumFractionDigits: 0,
                maximumFractionDigits: 2,
            }).format(decimal);
        } else {
            formattedPercent = "N/A";
        }
        return formattedPercent;
    };

    return (
        <Dialog
            className="dialog"
            open={showResponsesSentimentListDialog}
            handler={handleClose}
        >
            <DialogHeader className="dialog__header">
                Responses Sentiment
            </DialogHeader>
            <DialogBody className="dialog__body">
                <Typography className="text-black font-body">
                    A list of sentiment by individual response text with the
                    response text ID.
                </Typography>
                <div className="p-2 rounded-lg bg-white mt-2 w-full">
                    <GobbyTable>
                        <GobbyTableHead className="text-sm sm:text-lg">
                            <GobbyTableRow>
                                <GobbyTableHeader className="font-body w-1/12">
                                    ID
                                </GobbyTableHeader>
                                <GobbyTableHeader className="font-body w-7/12">
                                    Response Text
                                </GobbyTableHeader>
                                <GobbyTableHeader className="font-body w-1/12">
                                    Positive
                                </GobbyTableHeader>
                                <GobbyTableHeader className="font-body w-1/12">
                                    Neutral
                                </GobbyTableHeader>
                                <GobbyTableHeader className="font-body w-1/12">
                                    Negative
                                </GobbyTableHeader>
                                <GobbyTableHeader className="font-body w-1/12">
                                    Mixed
                                </GobbyTableHeader>
                            </GobbyTableRow>
                        </GobbyTableHead>
                        {!!(responsesSentimentData?.length > 0) && (
                            <GobbyTableBody className="">
                                {responsesSentimentData
                                    .filter((r) =>
                                        responseSentimentIdList?.includes(
                                            r.response_id,
                                        ),
                                    )
                                    ?.map((response, index) => (
                                        <GobbyTableRow
                                            key={response.response_id}
                                        >
                                            <GobbyTableCell className="text-center">
                                                {response.response_id}
                                            </GobbyTableCell>
                                            <GobbyTableCell className="text-left">
                                                {response.text}
                                            </GobbyTableCell>
                                            <GobbyTableCell>
                                                <span
                                                    className={`${
                                                        response.sentiment
                                                            ?.positive_score ===
                                                        response.sentiment
                                                            ?.score
                                                            ? "font-bold rounded-full text-center border border-2"
                                                            : ""
                                                    }`}
                                                >
                                                    {percentFormat(
                                                        response.sentiment
                                                            ?.positive_score,
                                                    )}
                                                </span>
                                            </GobbyTableCell>
                                            <GobbyTableCell>
                                                <span
                                                    className={`${
                                                        response.sentiment
                                                            ?.neutral_score ===
                                                        response.sentiment
                                                            ?.score
                                                            ? "font-bold rounded-full text-center border-white border border-2"
                                                            : ""
                                                    }`}
                                                >
                                                    {percentFormat(
                                                        response.sentiment
                                                            ?.neutral_score,
                                                    )}
                                                </span>
                                            </GobbyTableCell>
                                            <GobbyTableCell>
                                                <span
                                                    className={`${
                                                        response.sentiment
                                                            ?.negative_score ===
                                                        response.sentiment
                                                            ?.score
                                                            ? "font-bold rounded-full text-center border-white border border-2"
                                                            : ""
                                                    }`}
                                                >
                                                    {percentFormat(
                                                        response.sentiment
                                                            ?.negative_score,
                                                    )}
                                                </span>
                                            </GobbyTableCell>
                                            <GobbyTableCell>
                                                <span
                                                    className={`${
                                                        response.sentiment
                                                            ?.mixed_score ===
                                                        response.sentiment
                                                            ?.score
                                                            ? "font-bold rounded-full text-center border-white border border-2"
                                                            : ""
                                                    }`}
                                                >
                                                    {percentFormat(
                                                        response.sentiment
                                                            ?.mixed_score,
                                                    )}
                                                </span>
                                            </GobbyTableCell>
                                        </GobbyTableRow>
                                    ))}
                            </GobbyTableBody>
                        )}
                    </GobbyTable>
                </div>
            </DialogBody>
            <DialogFooter className="dialog__footer">
                <div className="">
                    <Button
                        type="button"
                        className="btn btn--primary m-2"
                        variant="filled"
                        onClick={handleClose}
                    >
                        Close
                    </Button>
                </div>
            </DialogFooter>
        </Dialog>
    );
}
